import React from "react";

import Imprint from "../../public/imprint"; // Imprint page component
import Login from "../../public/login"; // Login page component
import Privacy from "../../public/privacy"; // Privacy page component
import User from "../../private/pages/user";
import Admin from "../../private/pages/admin";
import Department from "../../private/pages/department";
import Religion from "../../private/pages/religion";
import Dashboard from "../../private/pages/dashboard";
import Page404 from "../../private/pages/page404";
import Invitation from "../../public/invitation";
import SuperAdminDashboard from "../../private/pages/dashboard/superAdminDashboard";
import Profile from "../../private/pages/employee/profile";
import Location from "../../private/pages/location";
import Settings from "../../private/pages/settings";
import UserTypes from "../../private/pages/userTypes";
import Company from "../../private/pages/company";
import SuperAdmin from "../../private/pages/superAdmin";
import Registration from "../../public/registration";
import Language from "../../private/pages/language";
import InvoiceData from "../../private/pages/invoiceData";
import PaymentDetails from "../../private/pages/paymentDetails";
import ForgetPassword from "../../public/forgetPassword";
import ResetPassword from "../../public/resetPassword";
import Contact from "../../private/pages/contact";
import Authorisations from "../../private/pages/authorisations";
import Whistleblowing from "../../private/pages/whistleblowing";
import WhistleCategory from "../../private/pages/whistleCategory";
import AdminCompany from "../../private/pages/AdminCompany";
import Support from "../../private/pages/support";
import HelpAndSupport from "../../private/pages/help&support";
import Statistics from "../../private/pages/statistics";
import CaseTags from "../../private/pages/tags";
import Consultant from "../../private/pages/consultant";
import CaseDeadlines from "../../private/pages/caseDeadlines";
import CompanyDetails from "../../private/pages/companyDetails";
import ReportingChannel from "../../private/pages/reportingChannel";
import ChannelPage from "../../public/channel";
import ChannelTrackPage from "../../public/track";
import Partner from "../../private/pages/partner";
import FAQManagement from "../../private/pages/faqManagement";
import FAQ from "../../public/FAQ";
import FaqCategory from "../../private/pages/faqCategory";
import DataPrivacy from "../../private/pages/dataPrivacy";
import Invoice from "../../private/pages/invoice";
import InvoiceProducts from "../../private/pages/invoiceProducts";

const Switch = ({ page, router }) => {
  switch (page) {
    case "login":
      return <Login />;
    case "forgetPassword":
      return <ForgetPassword />;
    case "resetPassword":
      return <ResetPassword />;
    case "user":
      return <User />;
    case "employees":
      return <User />;
    case "religion":
      return <Religion />;
    case "imprint":
      return <Imprint />;
    case "privacy":
      return <Privacy />;
    case "admin":
      return <Admin />;
    case "superAdmin":
      return <SuperAdmin />;
    case "department":
      return <Department />;
    case "dashboard":
      return <Dashboard />;
    case "dashboardSuperAdmin":
      return <SuperAdminDashboard />;
    case "profile":
      return <Profile />;
    case "invitations":
      return <Invitation />;
    case "language":
      return <Language />;
    case "location":
      return <Location />;
    case "userRoles":
      return <UserTypes />;
    case "company":
      return <Company />;
    case "invoiceData":
      return <InvoiceData />;
    case "paymentDetails":
      return <PaymentDetails />;
    case "company":
      return <Company />;
    case "companies":
      return <AdminCompany />;
    case "signup":
      return <Registration />;
    case "settings":
      return <Settings router={router} />;
    case "contact":
      return <Contact />;
    case "authorisations":
      return <Authorisations />;
    case "whistle":
      return <Whistleblowing />;
    case "category":
      return <WhistleCategory />;
    case "support":
      return <Support />;
    case "helpSupport":
      return <HelpAndSupport />;
    case "statistics":
      return <Statistics />;
    case "tags":
      return <CaseTags />;
    case "caseDeadlines":
      return <CaseDeadlines />;
    case "consultant":
      return <Consultant />;
    case "companyDetails":
      return <CompanyDetails />;
    case "reporting-channel":
      return <ReportingChannel />;
    case "channel":
      return <ChannelPage />;
    case "channel-track":
      return <ChannelTrackPage />;
    case "partner":
    case "partners":
      return <Partner />;
    case "faqManagement":
      return <FAQManagement />;
    case "faq":
      return <FAQ />
    case "faqCategory":
      return <FaqCategory />
    case "dataPrivacy":
      return <DataPrivacy />
    case "invoice":
    case "invoices":
      return <Invoice />;
    case "products":
      return <InvoiceProducts />;
    default:
      return <Page404 />;
  }
};

export default Switch;
